import React from 'react'
import { UserContext } from '../context'

export const useUserContext = () => React.useContext(UserContext)
